<template>
  <div class = "RegionSelect">
    <div class="PageHeader">
      <h2 class="PageHeader__subheading">{{$t("gsRegionSelectHeading")}}</h2>
    </div>
    <div class="Selection">
      <button v-for="region in parent.config.Regions" :key="region.id" class="Selection__item" v-on:click="selectRegion(region)"><span>{{ region.name }}</span></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GSRegionSelect',
  data: function() {
    return {
      parent: this.$parent
    }
  },
  methods: {
    selectRegion(region) {
      this.parent.state.region = region.id;
      this.$router.push({
        path: '/guest-services/productSelect'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/GuestServices/GSRegionSelect.vue